import { render } from "./Settings.vue?vue&type=template&id=b57a72f6"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/settings/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b57a72f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b57a72f6', __exports__)) {
    api.reload('b57a72f6', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=b57a72f6", () => {
    api.rerender('b57a72f6', render)
  })

}


export default __exports__